<template>
  <div class="collapseBox">
    <el-collapse accordion @change="changeHistory" v-model="activeName" v-if="historyList.length > 0">
      <el-collapse-item v-for="item in historyList" :key="item.orderId" :name="item.orderId">
        <template slot="title">
          <div class="title-top">
            <img :src="imgArr.a8" class="img-icon" v-if="item.specialRemark && (roles.includes('Doctor') || isHelper)">
            <el-tooltip class="item" effect="dark" :content="item.diagnosis || '-'" placement="top-start">
              <div class="histor-doctorName size13 font600 color0000" style="width: 100px;">{{ item.diagnosis || '-' }}
              </div>
            </el-tooltip>
            <div>
              <span class="histor-doctorName size12">{{ item.doctorName }}</span>
              <span class="size12">{{ item.date }}</span>
            </div>
          </div>
        </template>
        <div class="histor-content">
          <div class="content-top">
            <div style="width: 30%;" class="cypBtn pointer" @click="copyAll(item.orderId)" :class="{ 'none': isDisabled || isGroupOrder || orderInfo.isGroupOrder || item.orderId == orderId || isEdit }">
              复制全部
            </div>
            <div style="width: 30%;" class="cypBtn pointer" @click="copyCase()" :class="{ 'none': isDisabled || item.orderId == orderId }">复制病历</div>
            <el-dropdown @command="orderHandleCommand" style="width: 30%;">
              <div class="cypBtn pointer" >打印</div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="2">处方</el-dropdown-item>
                <el-dropdown-item command="3">病历</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
          <div class="content-top">
            <div class="font600">病历</div>
            <custom-button type="text" :class="{ 'none': isDisabled || item.orderId == orderId }" @click="copyCase()" :disabled="isDisabled">复制</custom-button>
          </div>
          <div class="content-item" v-if="item.patientTell">
            <div class="item-label">主诉：</div>
            <div class="item-value">{{ item.patientTell }}</div>
          </div>
          <div class="content-item" v-if="item.presentCondition">
            <div class="item-label">现病：</div>
            <div class="item-value">{{ item.presentCondition }}</div>
          </div>
          <div class="content-item" v-if="item.previousHistory">
            <div class="item-label">既往：</div>
            <div class="item-value">{{ item.previousHistory }}</div>
          </div>
          <div class="content-item" v-if="item.familyHistory">
            <div class="item-label">家族：</div>
            <div class="item-value">{{ item.familyHistory }}</div>
          </div>
          <div class="content-item" v-if="item.allergyHistory">
            <div class="item-label">过敏：</div>
            <div class="item-value">{{ item.allergyHistory }}</div>
          </div>
          <div class="content-item" v-if="item.menstrualHistory">
            <div class="item-label">月经史：</div>
            <div class="item-value" v-html="item.menstrualHistory"></div>
          </div>
          <div class="content-item" v-if="item.accessoryExamination">
            <div class="item-label">辅助检查：</div>
            <div class="item-value">{{ item.accessoryExamination }}</div>
          </div>
          <div class="content-item" v-if="item.physicalExamination">
            <div class="item-label">体格：</div>
            <div class="item-value">{{ item.physicalExamination }}</div>
          </div>
          <div class="content-item" v-if="item.facePalpation">
            <div class="item-label">四诊：</div>
            <div class="item-value">{{ item.facePalpation }}</div>
          </div>
          <div class="content-item" v-if="item.dialectical">
            <div class="item-label">辨证：</div>
            <div class="item-value">{{ item.dialectical }}</div>
          </div>
          <div class="content-item" v-if="item.specialRemark && (roles.includes('Doctor') || isHelper)" >
            <div class="item-label">特殊备注：</div>
            <div class="item-value">{{ item.specialRemark }}</div>
          </div>
          <div class="content-item" v-if="item.diagnosis">
            <div class="item-label">诊断：</div>
            <div class="item-value">{{ item.diagnosis }}</div>
          </div>
          <div class="content-item" v-if="!$lodash.isEmpty(item.images)">
            <div class="item-label">附件：</div>
            <div class="item-value"><el-image class="mr6" v-for="url in item.images" :key="url"
                style="width: 40px; height: 40px" :src="url" :preview-src-list="item.images">
              </el-image></div>
          </div>
          <template v-if="!$lodash.isEmpty(chooseHistory.drugItems)">
            <div class="size13 line20" v-for="(drug, ind) in chooseHistory.drugItems" :key="drug.orderCaseProjectRecipeId">

              <div class="content-top">
                <div class="font500">中药处方{{ ind + 1 }}<span v-if="drug.isYlcp == '1'">(医联)<span
                      v-if="drug.recipeName">{{ drug.recipeName }}</span></span></div>
                <custom-button type="text" @click="copyProject(drug)" :class="{ 'none': isDisabled }"
                  :disabled="isDisabled || isGroupOrder || orderInfo.isGroupOrder || drug.isYlcp == '1'">复制</custom-button>
              </div>
              <div class="drug-item" v-if="drug.isYlcp != '1'">
                <div v-for="drugItem in drug.items" :key="drugItem.artNo" style="width: 50%;display:flex;">
                  <div class="lineOne" style="width: 80px;">{{ drugItem.itemName }}</div>
                  <div> {{ drugItem.itemNum }} {{ drugItem.itemUnit }} </div>
                </div>
              </div>
              <div class="flex just-b color6671">
                <el-popover popper-class="content-doseNum-popper" placement="bottom" trigger="hover">
                  <!-- 2025-3-5-30 产品要求显示开方剂量 -->
                  <div slot="reference">{{ drug.realDoseNum ||  drug.doseNum}}剂</div>
                  <div class="size13 color6671">
                    <div v-if="drug.realDoseNum && orderInfo.status=='4'">购买：{{ drug.realDoseNum }}剂</div>
                    <div v-if="['8','-7','9','4'].includes(orderInfo.status)">开方：{{ drug.doseNum }}剂</div>
                  </div>
                </el-popover>
                <!-- 2025-07-28 改为后端计算 -->
                <div>¥{{ drug.recipeAmount }}</div>
              </div>
              <div v-if="drug.ingredients && drug.ingredients.length > 0" class="flex just-b color6671">
                <div>辅料：{{computedIngredients(drug.ingredients)}}</div>
              </div>
              <div v-if="drug.processFlag=='1'" class="flex just-b color6671">
                <div>加工：{{drug.process.processName}}</div>
                <div>¥{{ drug.isYlcp === '1' ? drug.process.processPrice * drug.doseNum : drug.process.processPrice }}</div>
              </div>
            </div>
          </template>
          <template v-if="!$lodash.isEmpty(chooseHistory.chineseMedicineItems)">
            <div class="size13 line20" v-for="(cm, ind) in chooseHistory.chineseMedicineItems" :key="cm.orderCaseProjectRecipeId">

              <div class="content-top">
                <div class="font500">中成药处方{{ ind + 1 }}</div>
                <custom-button type="text" :class="{ 'none': isDisabled }" @click="copyProject(cm)" :disabled="isDisabled || isGroupOrder || orderInfo.isGroupOrder">复制</custom-button>
              </div>
              <div class="combo-item" v-for="cmDrug in cm.items" :key="cmDrug.artNo">
                <div>{{ cmDrug.itemName }}</div>
                <div class="flex">
                  <div>{{ cmDrug.itemNum }}{{ cmDrug.itemUnit || '次' }}</div>
                  <div class="w60 textRight ml6"> ¥{{ computedMultiplication(cmDrug.itemNum,cmDrug.price)  }}</div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!$lodash.isEmpty(chooseHistory.phyItems)">
            <div class="size13 line20" v-for="(phy, ind) in chooseHistory.phyItems" :key="phy.orderCaseProjectRecipeId">

              <div class="content-top">
                <div class="font500">理疗处方{{ ind + 1 }}</div>
                <custom-button type="text" :class="{ 'none': isDisabled }" @click="copyProject(phy)" :disabled="isDisabled || isGroupOrder || orderInfo.isGroupOrder">复制</custom-button>
              </div>
              <div class="physio-item" v-for="(physioDrug,physioDrugIndex) in phy.items" :key="physioDrug.artNo">
                <div class="flex just-b">
                  <div>{{physioDrugIndex+1}}.{{ physioDrug.itemName }}</div>
                  <div class="flex">
                    <div class="w60 textRight ml6"> ¥{{ computedMultiplication(physioDrug.itemNum,physioDrug.price) }}</div>
                  </div>
                </div>
                <div class="flex">
                  <div>共{{ physioDrug.physioExtendJson && physioDrug.physioExtendJson.soldNum ? physioDrug.physioExtendJson.soldNum : physioDrug.itemNum }}次</div>
                  <div v-if="physioDrug.physioExtendJson && physioDrug.physioExtendJson.executionMode ==20 && physioDrug.physioExtendJson.onlyNum">,每次{{ physioDrug.physioExtendJson.onlyNum }}组</div>
                </div>
              </div>
            </div>
          </template>

          <template v-if="chooseHistory.actList && chooseHistory.actList.length > 0">
            <div v-for="(activity, activityIndex) in chooseHistory.actList" :key="`activity-${activityIndex}`" class="activity_item">
              <div class="activity_header">
                <div class="activity_header_left">
                  <el-tooltip effect="dark" :content="activity.actCseName" placement="top">
                    <div class="activity_header_name">{{ activity.actCseName }}</div>
                  </el-tooltip>
                  <div class="activity_header_tag">活动</div>
                </div>
                <div class="activity_header_right">￥{{ activity.totalPrice }}</div>
              </div>
              <div v-for="(project, projectIndex) in activity.items" :key="`project-${projectIndex}`" class="activity_row">
                <div class="activity_row_name">{{ project.drugType === 1 ? project.spuCommonName : project.itemName }}</div>
                <div class="activity_row_num">{{ project.itemNum }}{{ project.itemUnit }}</div>
              </div>
            </div>
          </template>

          <template v-if="chooseHistory.otherItems && !$lodash.isEmpty(chooseHistory.otherItems)">
            <div class="size13 line20" v-for="(other, ind) in chooseHistory.otherItems" :key="other.orderCaseProjectRecipeId">
              <div class="content-top">
                <div class="font500">非处方项目</div>
                <!-- <custom-button type="text" @click="copyProject(other)" :class="{ 'none': isDisabled || item.orderId == orderId }" :disabled="isDisabled">复制</custom-button> -->
              </div>
              <div class="combo-item" v-for="otherItem in other.items" :key="otherItem.artNo">
                <div>{{ otherItem.itemName }}<span v-if="otherItem.commodityType === 1">（赠品）</span></div>
                <div class="flex">
                  <div>{{ otherItem.itemNum }}{{ otherItem.itemUnit }}</div>
                  <div class="w60 textRight ml6"> ¥{{ computedMultiplication(otherItem.itemNum,otherItem.price) }}</div>
                </div>
              </div>
            </div>
          </template>
          <!-- 复诊 -->
           <div class="content-item just-b mt8" style="display: block;">
            <div class="item-label font500">复诊时间：</div>
            <div class="item-value">{{ completeRevisitTime(orderInfo)}}</div>
           </div>
          <!-- 补录挂号费 -->
          <div class="content-item just-b mt8" v-if="orderInfo.orderSourceType!='0' && orderInfo.orderSourceType!='5'">
            <div class="item-label font500">补录挂号费：</div>
            <div class="item-value">￥{{doctorInfo.registeredPrice}}</div>
          </div>
          <div class="content-item just-b mt8" v-if="chooseHistory.delivery && chooseHistory.delivery.bargainPrice">
            <div class="item-label font500">快递费：</div>
            <div class="item-value">￥{{chooseHistory.delivery.bargainPrice}}</div>
          </div>
          <div class="content-top" v-if="item.doctorAdviceArr && !$lodash.isEmpty(item.doctorAdviceArr)">
            <div class="font500">医嘱事项</div>
            <custom-button type="text" @click="copyAdvice()" :class="{ 'none': isDisabled || item.orderId == orderId }" :disabled="isDisabled">复制</custom-button>
          </div>
          <div class="size13 color6671" v-for="(adviceItem, index) in  item.doctorAdviceArr" :key="index">{{ adviceItem }}
          </div>
          <div class="content-bottom">
            <div>{{payInfo.completeTime}}</div>
            <el-popover popper-class="content-price-popper" placement="bottom" trigger="hover">
              <div slot="reference">
                  <div v-if="orderInfo.status=='4'" class="color29C0" >已收:￥{{payInfo.realPay }}</div>
                  <div v-if="orderInfo.status=='8'" class="colorFE8F" >待收:￥{{computedWaitPrice }}</div>
                  <div v-if="orderInfo.status=='-7'" class="color6671" >已退:￥{{payInfo.refundPrice }}</div>
                  <div v-if="orderInfo.status=='9'" class="color6671" >关闭:￥{{payInfo.totalPrice }}</div>
              </div>
              <div class="size13 color6671">
                <div v-if="['4','8','-7'].includes(orderInfo.status)">
                  <div class="flex">
                    <div>金额：</div>
                    <div class="w70 textRight">¥{{  orderInfo.orderPayFlag=='0'? computedWaitPrice: payInfo.totalPrice  }}</div>
                  </div>
                  <div class="flex">
                    <div>优惠：</div>
                    <div class="w70 textRight">¥{{payInfo.discountPrice > 0 ? `+${payInfo.discountPrice}` : payInfo.discountPrice  }}</div>
                  </div>
                  <div v-if="payInfo.refundPrice>0" class="flex">
                    <div>已退：</div>
                    <div class="w70 textRight">¥{{payInfo.refundPrice }}</div>
                  </div>
                  <div class="flex">
                    <div>应收：</div>
                    <div class="w70 textRight">¥{{ orderInfo.orderPayFlag=='0'? computedWaitPrice:  payInfo.realPay }}</div>
                  </div>
                  <div v-if="['4','-7'].includes(orderInfo.status)" class="flex color0000">
                    <div>实收：</div>
                    <div class="w70 textRight">¥{{payInfo.payPrice }}</div>
                  </div>
                  <div v-if="orderInfo.status=='8'"  class="flex">
                    <div>待收：</div>
                    <div class="w70 textRight">¥{{computedWaitPrice }}</div>
                  </div>
                </div>
                <div v-if="orderInfo.status=='9'">已关闭收费单</div>
              </div>
            </el-popover>
          </div>
          <div class="content-evaluate" v-if="evaluateObj">
            <div class="font600">患者评价</div>
            <div class="content-evaluate-item">
              <div>治疗效果：</div>
              <el-rate v-model="evaluateObj.efficacyEvaluation" disabled show-text :texts="Object.values(efficacyEvaluationMap)"> </el-rate>
            </div>
            <div v-if="evaluateObj.efficacyEvaluationContent">“{{ evaluateObj.efficacyEvaluationContent || '' }}”</div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- <div class="pagination-warp" v-if="historyList.length > 0">
      <el-pagination layout="prev, pager, next" :total="historyTotal" :current-page="pages.pageNum"
        @current-change="pageChange">
      </el-pagination>
    </div> -->
    <!-- 打印 -->
    <printDialog :printDialogShow="printDialogShow" v-show="printDialogShow"
      @closePrintPrescription="closePrintPrescription" ref="printDia" @setPrintDiaShow="setPrintDiaShow"
      @printSuccess="printSuccess" :isBatch="isBatch" :printListObj="printListObj" :id="activeName"
      :orderType="printorderType" :printType="printType" @printSuccessBatch="printSuccessBatch">
    </printDialog>
  </div>
</template>

<script>
import { Outpatient, Common } from '../data';
import printDialog from '@/components/printDialog';
import { prescriptionDTO } from '@/DTO/index'
import { isEmptyArray,isNull,isNullObj,debounce } from '@/utils/validateBase';
import { efficacyEvaluationMap } from '@/utils/config_evaluate.js'
import { getEvaluate } from '@/api/evaluate'
import { imgArr } from '@/assets/images/img.js'

export default {
  props: {
    historyList: Array,
    patientForm: Object,
    doctorId: Number,
    orderId: Number | Number,
    isDisabled: Boolean,
    isGroupOrder: Boolean,
    isEdit: Boolean,
    isHelper: Boolean,
    editForm: Object
  },
  components: {
    printDialog,
  },
  data() {
    return {
      // historyList: [],//历史诊断
      pages: {
        pageNum: 1,
        pageSize: 10
      },
      activeName: null,
      chooseHistory: {},//选择的历史病历
      isBatch: false,//是否批量打印
      recipesList: [],//所有的处方
      printDialogShow: false,//打印弹框
      printListObj: [],//批量打印列表
      printorderType: '',//打印处方订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
      printType: '',///打印类型 1小票 2处方
      orderInfo:{},
      payInfo:{},
      doctorInfo:{},
      evaluateObj:null,
      efficacyEvaluationMap:efficacyEvaluationMap,
      roles:[],
      imgArr:imgArr,
    }
  },
  watch: {
    historyList: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(this.historyList)) {
          this.activeName = this.historyList[0].orderId
          this.changeHistory(this.historyList[0].orderId)
          if (this.activeName == this.orderId) {
            // this.isDisabled = true
          }
        }
      }
    }
  },
  computed:{
    completeRevisitTime(){
      return function(orderInfo){
        if(orderInfo.revisitFlag == '0'){
          return `无需复诊;${orderInfo.revisitNotes || ''}`
        }else if(orderInfo.revisitFlag == '1'){
          return `${isNull(orderInfo.revisitTime) ? '' : orderInfo.revisitTime + ';'}${orderInfo.revisitNotes || ''}`
        }else if(orderInfo.revisitFlag == '2'){
          return `根据病情需要复诊;${orderInfo.revisitNotes || ''}`
        }else{
          return ''
        }
      }
    },
    computedWaitPrice(){
        let price = 0
        let {orderPayFlag} = this.orderInfo
        let {waitPrice,totalPrice}=this.payInfo
        if(orderPayFlag=='0'){
          //未生成订单
          let judgeRegisterObj = this.judgeRegister()
          if(judgeRegisterObj.flag){
            //有补录挂号费
            price = this.$bigNumber(totalPrice,'+',judgeRegisterObj.registerPrice)
          }else{
            price = totalPrice
          }
          if(!isNull(this.chooseHistory.delivery) && !isNullObj(this.chooseHistory.delivery)){
            price = this.$bigNumber(price,'+',this.chooseHistory.delivery.bargainPrice)
          }
        }else{
          //已经生成订单待收取waitPrice
          price=waitPrice
        }
        return price;
    },
     //乘法
    computedMultiplication() {
      return function (a, b) {
          if (isNull(a) || isNull(b)) return
          return this.$bigNumber(a, '*', b,2)
      }
    },
    computedRecipeTotal(){
      return function (drug) {
          let total = 0
          drug.items && drug.items.forEach(item => {
            let temp = this.computedMultiplication(isNull(drug.realDoseNum) ? drug.doseNum : drug.realDoseNum, item.itemNum)
            total = this.$bigNumber(total, '+', this.computedMultiplication(item.price, temp))
          })
          return total;
      }
    },
    computedIngredients(){
      return function(ingredientsTemplateDetails){
        let res =  ingredientsTemplateDetails.map(v2 => {
          let str = `${v2.oriName}${v2.oriNum}${v2.oriUnit}`;
          if (v2.oriHandling) {
            str += v2.oriHandling;
          }
          return str;
        }).join('，');
        return res
      }
    }
    
  },
  created() { 
    this.roles = this.$session.get('roles')
  },
  methods: {
    //打印处方和病例
    orderHandleCommand(val) {
      this.printType = val
      switch (val) {
        case '2':
          const actHasOrderList = this.chooseHistory.actList.filter(v => { return ![null, undefined, ''].includes(v.orderCaseProjectRecipeId) })
          if (_.isEmpty(this.chooseHistory.drugItems) && _.isEmpty(this.chooseHistory.phyItems) && _.isEmpty(this.chooseHistory.chineseMedicineItems) && _.isEmpty(actHasOrderList)) {
            this.$message.error('暂无处方')
            return
          }
          this.isBatch = true
          let printListObj = []
          this.chooseHistory.drugItems.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '1'
            })
          })
          this.chooseHistory.phyItems.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '2'
            })
          })
          this.chooseHistory.chineseMedicineItems.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '1'
            })
          })
          actHasOrderList.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '2'
            })
          })
          this.printListObj = printListObj
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '3':
          this.isBatch = false;
          this.printorderType = '4'
          this.printType = '6'
          this.printOrderId = this.activeName
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
      }
    },/**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 打印完成
     */
    printSuccess() {

    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },
    //批量打印完成
    printSuccessBatch() {
      this.$message.success('打印成功消息发送成功')
    },
    /**
* 切换历史诊断
*/
    changeHistory(val) {
      if (!val) return
      console.log('orderis', this.orderId, this.activeName);
      this.activeName = val
      // if (this.activeName == this.orderId) {
      //   this.isDisabled = true
      // } else {
      //   this.isDisabled = false
      // }
      Outpatient.getHistoryDoor({ orderId: val }).then(res => {
        if(res.code==200){
          if (!_.isEmpty(res.data.projectRecipes)) {
            res.data.drugItems = Common.filterDiagnosis(res.data.projectRecipes, 'drug')
            res.data.chineseMedicineItems = Common.filterDiagnosis(res.data.projectRecipes, 'chineseMedicine')
            res.data.phyItems = Common.filterDiagnosis(res.data.projectRecipes, 'phy')
            res.data.otherItems = Common.filterDiagnosis(res.data.projectRecipes, 'other') || []
            //判断是否有补录挂号费
            // let judgeRegisterObj= this.judgeRegister(res.data.orderDetail)
            // if(judgeRegisterObj.flag){ 
            //     if(isEmptyArray(res.data.otherItems)){
            //       res.data.otherItems.push({
            //         items:{}
            //       })
            //       res.data.otherItems[0].items=[]
            //     }
            //     res.data.otherItems[0].items.push({
            //         itemName:'补录挂号费',
            //         itemNum:1,
            //         price:judgeRegisterObj.registerPrice,
            //       })
            // }
          }

          res.data['actList'] = res.data.actGroups || []
          
          this.chooseHistory = res.data;
          this.orderInfo = res.data.orderDetail.order
          this.doctorInfo = res.data.orderDetail.doctor
          this.payInfo = res.data.payInfo
        }
      })
      this.getEvaluateInfo(val)
    },
    //处理历史诊断格式
    /**
* 历史病例页码改变
*/
    pageChange(val) {
      this.pages.pageNum = val
      this.getHistoryList()
    },
    /**
* 复制历史诊断全部
*/
    copyAll:debounce(function(id){
      let obj = {
        sourceOrderId: id,
        orderId: this.orderId
      }
      this.$parent.$parent.menstrualHistoryHtml=''
      this.$parent.$parent.menstrualHistory=[]
      Outpatient.copyAllHistory(obj).then(res=>{
        if(this.isEdit){
          this.$parent.$parent.historyPageNum=1
          this.$parent.$parent.hasMoreHistoryList=true
          this.$parent.$parent.getHistoryList()
        }
        this.$emit('getOutPatientAll', this.orderId)
      })
    },1000,true),
    /**
    * 复制病例 
    */
   copyCase:debounce(function(){
    this.$parent.$parent.menstrualHistoryHtml=''
      this.$parent.$parent.menstrualHistory=[]
      let caseDiagnosis = _.cloneDeep(this.chooseHistory.orderCaseDiagnosis)
      delete caseDiagnosis.orderId
      delete caseDiagnosis.orderCaseDiagnosisId
      delete caseDiagnosis.doctorAdvice
      delete caseDiagnosis.images
      let obj = {
        orderId: this.orderId,
        ...this.editForm,
        ...caseDiagnosis,
        specialRemark:''
      }
      Outpatient.editCaseDiagnosis(obj).then(res => {
        if(this.isEdit){
          this.$parent.$parent.historyPageNum=1
          this.$parent.$parent.hasMoreHistoryList=true
          this.$parent.$parent.getHistoryList()
        }
        this.$emit('getOutPatientAll', this.orderId)
      })
   },1000,true),
    /**
   * 复制医嘱
   */
   copyAdvice:debounce(function(){
    let editForm = _.cloneDeep(this.editForm)
      editForm.doctorAdvice = this.chooseHistory.orderCaseDiagnosis.doctorAdvice
      let obj = {
        orderId: this.orderId,
        ...editForm,
        images: _.toString(editForm.imgs)
      }
      delete obj.imgs
      Outpatient.editCaseDiagnosis(obj).then(res => {
        if(this.isEdit){
          this.$parent.$parent.historyPageNum=1
          this.$parent.$parent.hasMoreHistoryList=true
          this.$parent.$parent.getHistoryList()
        }
        this.$emit('getOutPatientAll', this.orderId)
      })
   },1000,true),
    /**
     * 复制项目
     */
     copyProject:debounce(function(val){
      let item = _.cloneDeep(val)
      let obj = {
        sourceCaseProjectRecipeId: item.orderCaseProjectRecipeId,
        orderId: this.orderId
      }
      prescriptionDTO.projectCopyDTO(obj).then(res => {
        if(this.isEdit){
          this.$parent.$parent.historyPageNum=1
          this.$parent.$parent.hasMoreHistoryList=true
          this.$parent.$parent.getHistoryList()
        }
        this.$emit('getOutPatientAll', this.orderId)
      })
    },1000,true),
    /**
     * 判断是否有补录挂号费
     */
     judgeRegister(){
      let obj = { flag:false,registerPrice:0}
      let {doctor,order}=this.chooseHistory.orderDetail
      if(order.orderSourceType!='0' && order.orderSourceType!='5'){
        obj.flag=true;
        obj.registerPrice = doctor.registeredPrice
      }
      return obj
    },
    //获取评价信息
    async getEvaluateInfo(orderId){
      this.evaluateObj = null
      let {code ,data} = await getEvaluate(orderId)
      if(code==200){
        this.evaluateObj = data || null
      }
    },
  }
}
</script>

<style lang="less">
.content-price-popper{
  background: #FFFDE9;
  min-width: 119px;
  box-sizing: border-box;
}
.content-doseNum-popper{
  background: #FFFDE9;
  min-width: 80px;
  box-sizing: border-box;
}
</style>
<style lang="less" scoped>
.collapseBox {
  flex: 1;

  .el-collapse {

    border: none;

    /deep/ .el-collapse-item__content {
      padding: 6px 16px;
      background: #FAFBFC;
      border-top: 1px #D3D3D5 solid;
    }

    .title-top {
      width: 100%;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }
    .img-icon{
      width: 14px;
      height: 14px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      font-size: 14px;
      color: #f72626;
    }

    .histor-doctorName {
      // color: #666;
      // font-size: 14px;
      margin-right: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex-grow: 0;
      flex-shrink: 0;
      width: 70px;
      margin-left: 16px;
    }

    .histor-content {
      color: #444;
      .content-top {
        // margin-top: 8px;
        display: flex;
        color: #667182;
        font-size: 13px;
        font-weight: 500;
        align-items: center;
        justify-content: space-between;

        .cypBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #D3D3D5;
          border-radius: 2px 2px 2px 2px;
          background: #FFFFFF;
          height: 26px;

          &:hover {
            color: #1890ff;
            border-color: #badeff;
            background-color: #e8f4ff;
          }
        }
      }
      .content-bottom{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #667182;
        margin-top: 8px;
        border-top: 1px #E0E0E0 dashed;
        padding-top: 8px;
      }
      .content-item {
        display: flex;
        color: #667182;
        font-size: 13px;

        .item-label {
          font-size: 13px;
          font-weight: 400;
          flex-grow: 0;
          flex-shrink: 0;
        }

        .item-value {
          font-size: 13px;
          font-weight: 400;
          overflow-wrap: break-word;
          white-space: pre-wrap;
        }
      }
      .content-evaluate{
        padding-top: 8px;
        color: #667182;
        font-size: 13px;
        border-top: 1px dashed #E0E0E0;
        .content-evaluate-item{
          display: flex;
          align-items: center;
        }
      }
      .combo-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #667182;
      }
      .physio-item{
        color: #667182;
        margin-bottom: 2px;
      }
      .drug-item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 13px;
        color: #667182;
        line-height: 20px;

      }
    }
  }
}

.none {
  pointer-events: none;
  color: #B8B8B8;
}

.pagination-warp {
  margin-top: 20px;
}
/deep/.el-rate__item{
  width: 18px;
}

.activity_item {
  margin: 6px 0;
  width: 100%;
}

.activity_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.activity_header_left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.activity_header_name {
  max-width: 160px;
  line-height: 20px;
  font-weight: 500;
  font-size: 13px;
  color: #667182;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.activity_header_tag {
  margin: 0 0 0 4px;
  padding: 0 6px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #A566FE;
  background-color: #F5E7FF;
  border-radius: 2px;
  white-space: nowrap;
}

.activity_header_right {
  line-height: 20px;
  font-size: 13px;
  color: #667182;
}

.activity_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.activity_header + .activity_row {
  margin: 3px 0 0 0;
}

.activity_row_name {
  line-height: 20px;
  font-size: 13px;
  color: #667182;
}

.activity_row_num {
  line-height: 20px;
  font-size: 13px;
  color: #667182;
}
</style>